import { IError, IQueryHookOptions } from '@comptia-sso/core';
import { UseMutateAsyncFunction, useMutation } from 'react-query';

// Services.
import { deleteProfile } from 'services';

type DeleteProfileFunction = UseMutateAsyncFunction<
  { success: boolean },
  IError
>;

type UseDeleteProfile = [DeleteProfileFunction, IQueryHookOptions];

export const useDeleteProfile = (profileId = ''): UseDeleteProfile => {
  const { error, isError, isLoading, mutateAsync } = useMutation<
    { success: boolean },
    IError
  >(() => deleteProfile(profileId));

  return [mutateAsync, { error, isError, isLoading }];
};
